import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import { useEffect } from "react";
import { ChartGrid, FilterDrawer } from "../components";
import { SearchBar } from "../components/filters";
import { TOP_BAR_HEIGHT, useHideFilterDrawer } from "./AppLayout";
import { useSearchStore } from "../store/useSearchStore";

export default function HomePage() {
  const { applyDefaultSearchState } = useSearchStore();
  const { hideFilterDrawer, setHideFilterDrawer } = useHideFilterDrawer();
  const theme = useTheme();
  const marginTransition = `margin ${theme.transitions.duration.enteringScreen}ms`;

  // Move effect call outside of render to avoid anti-pattern
  useEffect(() => {
    applyDefaultSearchState();
  }, []);

  // Default the filter drawer to open so the hamburger icon is shown
  useEffect(() => {
    setHideFilterDrawer(false);
  }, []);

  return (
    <>
      <FilterDrawer topPadding={50} hideFilterDrawer={hideFilterDrawer} />
      <Box
        component="main"
        sx={{
          marginLeft: hideFilterDrawer !== false ? 0 : 37.5,
          p: 0,
          transition: marginTransition,
          flexGrow: 1,
          paddingTop: `${TOP_BAR_HEIGHT}px`,
        }}
      >
        <div style={{ padding: "24px" }}>
          <SearchBar />
          <ChartGrid />
        </div>
      </Box>
    </>
  );
}
